export const MOUSE_BUTTON_CODES = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
};

export const YES = 'Yes';
export const NO = 'No';
export const YES_NO = [
  { label: YES, value: true },
  { label: NO, value: false },
];

export const ACTIVE = 'Active';
export const NOT_ACTIVE = 'Not active';
export const IS_ACTIVE = [
  { label: ACTIVE, value: true },
  { label: NOT_ACTIVE, value: false },
];

export const IS_OUR_CLIENT = 'Is our client';
export const NOT_OUR_CLIENT = 'Not our client';
export const IS_CLIENT = [
  { label: 'Is our client', value: true },
  { label: 'Not our client', value: false },
];

export const FilesSeparatlyId = 1;
export const FilesUnderParentId = 2;

export const FilingStatuses = {
  FilesSeparatly: 'Files separately',
  FilesUnderParent: 'Files under parent',
};

export const PARENT_RELATIONSHIP_TYPE = {
  id: 1,
  name: 'Parent',
  categoryId: 1,
};

export const SUBSIDIARY_RELATIONSHIP_TYPE = {
  id: 3,
  name: 'Subsidiary',
  categoryId: 2,
};

export const K1_OUTSIDE_PROVIDER = { id: 1, name: 'K1 provider' };

export const ErrorMessages = {
  FIELD_IS_REQUIRED: 'Fill in this field to proceed',
  NEGATIVE_AMOUNT_NOT_ALLOWED: 'Amount cannot be negative',
  INVALID_TAX_YEAR_LENGTH: 'Please enter a 4 digit year',
  INVALID_TAX_YEAR: 'Please enter a valid 4-digit year',
  INVALID_EMAIL_FORMAT: 'Invalid email format',
  INVALID_DATE: 'Enter a valid date',
  INVALID_INDIVIDUAL_FED: 'Enter a valid SSN (e.g. 123-45-6789)',
  INVALID_FED: 'Enter a valid EIN (e.g. 12-3456789)',
  INVALID_ROUTING_NUMBER: 'Enter a valid routing number (i.e. 123456789)',
  INVALID_ACCOUNT_NUMBER: 'Enter a valid account number (i.e. 123456789)',
  INVALID_EXPIRATION_DATE: 'Enter a valid expiration date (i.e. 12/2024)',
  INVALID_SECURITY_CODE: 'Enter a valid security code (i.e. 1234)',
  DUPLICATE_PAYMENT_DESCRIPTION:
    'There is another payment method with the same description',
  IS_ACTIVE_FIELD:
    "The 'Is active' field only applies to our clients. Please update the client type to 'Not our client' or update the 'Is active' status to 'Active'",
  ENDING_DATE_IS_AFTER_STARTING: 'Ending date must be after the starting date',
  PASSWORD_TO_SHORT: 'Password must be at least 6 characters long',
  PASSWORD_DONT_MATCH: 'Passwords do not match',
  COMMISSION_RATE_TO_LOW: 'Commision rate must be at least 0.01',
  WORKFLOW_REQUIRED_MUST_BE_CHECKED:
    "A workflow assignment must always be required. Please check the 'Required' checkbox to continue.",
  WORKFLOW_CAN_BE_DELETED_MUST_BE_UNCHECKED:
    "A workflow assignment cannot be deleted. Please uncheck the 'Can be deleted' checkbox to continue.",
  RESERVED_ASSIGNMENT_NAME:
    "'Final' is a reserved name used by the system. Please choose a different name.",
  TEMPLATE_MUST_HAVE_RECURRENCE: (templateType: string) =>
    `A ${templateType} template must have a recurrence set up. Please add a recurrence before saving.`,
  SERVICE_ENDING_REQUIRED_FOR_NOT_OUR_CLIENT: (
    clientName: string,
    serviceStartDate: string
  ) =>
    `${clientName ? clientName : 'The client'} has been serviced since ${serviceStartDate} and is no longer our client. Please enter the service ending date.`,
  NAME_ALREADY_IN_USE_ON_CLIENT_TEMPLATE:
    'This name is already in use on this client template. Please enter a different name.',
  ASSIGNMENT_ALREADY_IN_USE_ON_TASK:
    'There is already an assignment with this name on this task. Please enter a different name.',
  STARTING_DATE_ADJUSTED: (newDate: string) =>
    `The Starting date was adjusted to ${newDate} to align with the recurrence settings. If a different date is needed, please enable 'Override recurrence dates' below.`,
  DATE_BEFORE_MIN: (minDate: string) =>
    `Date cannot be earlier than ${minDate}.`,
  DATE_AFTER_MAX: (maxDate: string) => `Date cannot be later than ${maxDate}.`,
  STARTING_DATE_MUST_ALIGN: (newDate: string) =>
    `The Starting date must align with the dates of the recurrence settings, and was adjusted to ${newDate} as the nearest applicable date.`,
  STARTING_DATE_BEFORE_ESTABLISHED: (newDate: string) =>
    `The Starting date cannot be earlier than the client's Date established, so it was adjusted to ${newDate}.`,
};

export const SCROLL_BUTTON = 1;
